import React from "react";
import {
  Box,
  Chip,
  Divider,
  ListItem,
  ListItemButton,
  Stack,
  Typography,
} from "@mui/material";
import { Copyable } from "../../../copyable/Copyable";
import { useTranslation } from "../../../../hooks/useTranslation";
import { ProductDetail } from "../../../../pages/product/components/types";
import { InfoRow } from "./InfoRow";

type Props = {
  product: ProductDetail;
  isDevEnv: boolean;
  onSelect: () => void;
};

export const ProductResultItem: React.FC<Props> = ({
  product,
  isDevEnv,
  onSelect,
}) => {
  const { translateWithoutPrefix } = useTranslation("");

  const statusLabel = translateWithoutPrefix(
    "pages.orders.list.fields.status.title",
  );

  const fallbackImage = isDevEnv ? "/icons/logo-dev.svg" : "/icons/logo.svg";
  const imageSrc = product.productImageUrl || fallbackImage;

  return (
    <React.Fragment>
      <ListItem disablePadding>
        <ListItemButton
          onClick={onSelect}
          sx={{
            alignItems: "flex-start",
            gap: 1.5,
            py: 1.2,
          }}
        >
          <Box
            component="img"
            src={imageSrc}
            alt="product"
            sx={{
              width: 56,
              height: 56,
              objectFit: "contain",
              borderRadius: 1.5,
              flexShrink: 0,
              backgroundColor: "background.paper",
            }}
          />
          <Stack gap={1}>
            {product.marketplaceProduct?.itemName && (
              <Typography
                variant="caption"
                fontWeight={600}
                sx={{ lineHeight: 1.3 }}
              >
                {product.marketplaceProduct.itemName}
              </Typography>
            )}
            <InfoRow label="ASIN">
              <Copyable
                size="small"
                initialLabel={product.asin?.toUpperCase() ?? ""}
              />
            </InfoRow>
            {product.sku && (
              <InfoRow label="SKU">
                <Copyable size="small" initialLabel={product.sku} />
              </InfoRow>
            )}
            {product.storeProductStatus && (
              <InfoRow label={statusLabel}>
                <Chip
                  size="small"
                  label={product.storeProductStatus}
                  sx={{ fontSize: 11 }}
                />
              </InfoRow>
            )}
          </Stack>
        </ListItemButton>
      </ListItem>
      <Divider sx={{ borderColor: "primary.main" }} />
    </React.Fragment>
  );
};
